import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useEffect, useState, useContext } from 'react'
import InventoryCaptureTask from './InventoryCaptureTask'
import SurveyTask from './SurveysTask'
import PlanimetryVerificationTask from './PlanimetryVerificationTask'
import PriceCaptureTask from './PriceCaptureTask'
import { TextField, MenuItem } from '@mui/material'
import cookie from 'react-cookies'
import StickyActionBar from '../../components/StickyActionBar'
import SpecialFormHeaderActions from '../../components/action_button/SpecialFormHeaderActions'
import { TaskStickyAlertSlotContext } from './components/OneTimeMandatoryAlert'
import { TASK_TYPES } from '../constants/constants'

const TaskLayout = () => {
  const taskTypeOptions = [
    { value: '', text: 'Escoja una opción', hidden: true },
    { value: TASK_TYPES.inventory.key, text: TASK_TYPES.inventory.name },
    { value: TASK_TYPES.planimetry.key, text: TASK_TYPES.planimetry.name },
    { value: TASK_TYPES.survey.key, text: TASK_TYPES.survey.name },
    { value: TASK_TYPES.price_capture.key, text: TASK_TYPES.price_capture.name }
  ]

  const [selectedTaskType, setSelectedTaskType] = useState(null)
  const [saving, setSaving] = useState(false)
  const [readyToCollect, setReadyToCollect] = useState(false)
  const [failedCreation, setFailedCreation] = useState(false)
  const [taskData, setTaskData] = useState(null)
  const [cloningTask, setCloningTask] = useState(false)
  const [isRequired, setIsRequired] = useState(false)

  const [showProductAlert, setShowProductAlert] = useState(false)
  const [isSurveyLimitReached, setIsSurveyLimitReached] = useState(false)
  const [isSurveyImageLimitReached, setIsSurveyImageLimitReached] = useState(false)

  const [isStep3Completed, setIsStep3Completed] = useState(false)
  const [stickyAlertSlot, setStickyAlertSlot] = useState(null)

  const handleTaskTypeChange = (event) => {
    setSelectedTaskType(event.target.value)
  }

  const sendForm = (event) => {
    event.preventDefault()

    if (isSurveyLimitReached) {
      setFailedCreation(
        'No es posible guardar la tarea porque supera el límite permitido de 50 preguntas. Para continuar,  elimine las preguntas que excedan el límite e intente guardar nuevamente.'
      )
      return
    }

    if (isSurveyImageLimitReached) {
      setFailedCreation(
        'Límite alcanzado: Solo puedes habilitar imágenes en 25 preguntas por encuesta. Para continuar, deshabilita la opción de adjuntar imagen/es en otra pregunta.'
      )
      return
    }

    if (!isStep3Completed) {
      return
    }
    setFailedCreation(false)
    setReadyToCollect(true)
    setIsRequired(false)
    setShowProductAlert(false)
  }

  const formDataCollector = (data) => {
    let finalData = {
      ...data,
      business_uid: cookie.load('business_tenant_uid'),
      task_type: selectedTaskType
    }
    postTaskToBackend(finalData)
    setReadyToCollect(false)
  }

  const postTaskToBackend = (body) => {
    setSaving(true)
    authFetch(`${BASE_BACKEND_URL}/pos_tasks`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
      .then((r) => evaluateResponse(r))
      .catch((e) => console.log(e))
  }

  const startCloning = async (uuid) => {
    let taskToClone = await getTaskToClone(uuid)
    if (taskToClone) {
      setSaving(true)
      setSelectedTaskType(taskToClone.task_type)
      setTaskData(taskToClone)
    }
  }

  const getTaskToClone = async (uuid) => {
    const response = await authFetch(`${BASE_BACKEND_URL}/pos_tasks/${uuid}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
        if (!response) return

    if (response.status != 200) {
      return false
    } else {
      let json = await response.json()
      return json
    }
  }

  const setQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const uuidToClone = urlParams.get('clone') || ''
    if (uuidToClone) {
      startCloning(uuidToClone)
    }
  }

  const handleCloseAlert = () => {
    setShowProductAlert(false)
  }

  useEffect(() => {
    setQueryParams()
  }, [])

  const evaluateResponse = async (response) => {
    // navigate to task details
    switch (response.status) {
      case 422:
      case 409:
        setFailedCreation(
          'Error al crear la nueva tarea. Hay otra tarea idéntica. Modifique la tarea actual o suspenda la tarea existente antes de continuar'
        )
        setSaving(false)
        break
      case 404:
      case 400:
        setFailedCreation('Servidor fuera de linea. Intente más tarde')
        setSaving(false)
        break
      case 500:
        setFailedCreation('Error interno del sistema. Intente más tarde')
        setSaving(false)
        break
      default:
        let data = await response.json()
        setFailedCreation(false)
        // redirect to task details
        window.location = `/ejecucion_punto_venta/detalles/${data['uuid']}?success=true`
        break
    }
  }

  const handleSearch = (event) => {
    // search action occurs after ENTER is pressed
    if (event.keyCode === 13) {
      // to disbale submit form
      event.preventDefault()
      const query = event.target.value
      if (query !== '') {
        window.location = `/ejecucion_punto_venta?query=${query}`
      }
    }
  }

  const cancelCreate = (event) => {
    event.preventDefault()
    const val = window.confirm(
      '¿Esta seguro que quiere continuar? Los cambios editados no seran guardados'
    )
    if (val) {
      window.location = '/ejecucion_punto_venta'
    }
  }

  return (
    <TaskStickyAlertSlotContext.Provider value={{ node: stickyAlertSlot }}>
    <div>
      <div>
        <div onKeyDown={handleSearch}>
        </div>
        <div>
          <>
            <div className="show-title">
              <h2>Crear nueva tarea en punto de venta</h2>
            </div>
            <form onSubmit={sendForm}>
              <div className="task-create-sticky-stack">
                <StickyActionBar title="Ingrese los siguientes datos para crear una nueva tarea">
                  <SpecialFormHeaderActions
                    actionsOnly
                    actions={[
                      {
                        key: 'cancel',
                        label: 'Cancelar',
                        onClick: cancelCreate,
                        disabled: saving
                      },
                      {
                        key: 'save',
                        label: saving ? 'Guardando...' : 'Guardar',
                        type: 'submit',
                        variant: 'contained',
                        icon: 'check_circle',
                        iconProps: {
                          filled: false,
                          size: 22
                        },
                        disabled: saving || !isStep3Completed
                      }
                    ]}
                  />
                </StickyActionBar>
                {failedCreation && (
                  <div className="alert alert-danger" role="alert">
                    <strong>{failedCreation}</strong>
                  </div>
                )}
                {showProductAlert && (
                  <div className="alert alert-danger" role="alert">
                    <strong className="ml-65">
                      Por favor, completa todos los campos obligatorios antes de guardar.
                    </strong>
                    <button
                      type="button"
                      className="close mt--20"
                      onClick={() => setShowProductAlert(false)}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                <div ref={setStickyAlertSlot} className="task-create-sticky-stack__toasts" />
              </div>
              <div className="index-table task-create-form">
                <div className="show-area">
                  <div className="create-promo-wrapper">
                    {cloningTask && (
                      <div className="task-form-section">
                        <div className="title-promos-form">
                          <b>Cargando tarea...</b>
                        </div>
                      </div>
                    )}
                    {!cloningTask && (
                      <div className="task-form-section">
                        <div className="title-promos-form">
                          <b class="bold-step">PASO 1: Escoja el tipo de tarea a crear</b>
                        </div>
                        <hr className="hr-task-form" />
                        <div className="task-form-control-width">
                          <TextField
                            select
                            fullWidth
                            label="Tipo de tarea"
                            value={selectedTaskType || ''}
                            onChange={handleTaskTypeChange}
                            size="small"
                          >
                            {taskTypeOptions.map((option) => (
                              <MenuItem
                                key={option.value}
                                value={option.value}
                                disabled={option.hidden}
                              >
                                {option.text}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                      </div>
                    )}
                    {selectedTaskType === TASK_TYPES.inventory.key && (
                      <InventoryCaptureTask
                        taskData={taskData}
                        setCloningTask={setCloningTask}
                        cloningTask={cloningTask}
                        setFailedCreation={setFailedCreation}
                        failedCreation={failedCreation}
                        readyToCollect={readyToCollect}
                        setReadyToCollect={setReadyToCollect}
                        formDataCollector={formDataCollector}
                        setSaving={setSaving}
                        isStep3Completed={isStep3Completed}
                        setIsStep3Completed={setIsStep3Completed}
                      />
                    )}
                    {selectedTaskType === TASK_TYPES.planimetry.key && (
                      <PlanimetryVerificationTask
                        taskData={taskData}
                        setCloningTask={setCloningTask}
                        cloningTask={cloningTask}
                        setFailedCreation={setFailedCreation}
                        failedCreation={failedCreation}
                        readyToCollect={readyToCollect}
                        setReadyToCollect={setReadyToCollect}
                        formDataCollector={formDataCollector}
                        setSaving={setSaving}
                        isStep3Completed={isStep3Completed}
                        setIsStep3Completed={setIsStep3Completed}
                      />
                    )}
                    {selectedTaskType === TASK_TYPES.survey.key && (
                      <SurveyTask
                        setIsSurveyLimitReached={setIsSurveyLimitReached}
                        setIsSurveyImageLimitReached={setIsSurveyImageLimitReached}
                        taskData={taskData}
                        setCloningTask={setCloningTask}
                        cloningTask={cloningTask}
                        setFailedCreation={setFailedCreation}
                        failedCreation={failedCreation}
                        readyToCollect={readyToCollect}
                        setReadyToCollect={setReadyToCollect}
                        formDataCollector={formDataCollector}
                        setSaving={setSaving}
                        isStep3Completed={isStep3Completed}
                        setIsStep3Completed={setIsStep3Completed}
                      />
                    )}
                    {selectedTaskType === TASK_TYPES.price_capture.key && (
                      <PriceCaptureTask
                        taskData={taskData}
                        setCloningTask={setCloningTask}
                        cloningTask={cloningTask}
                        setFailedCreation={setFailedCreation}
                        failedCreation={failedCreation}
                        readyToCollect={readyToCollect}
                        formDataCollector={formDataCollector}
                        setSaving={setSaving}
                        setReadyToCollect={setReadyToCollect}
                        setShowProductAlert={setShowProductAlert}
                        isStep3Completed={isStep3Completed}
                        setIsStep3Completed={setIsStep3Completed}
                      />
                    )}
                  </div>
                </div>
              </div>
            </form>
          </>
        </div>
      </div>
    </div>
    </TaskStickyAlertSlotContext.Provider>
  )
}
export default TaskLayout
